import Swal from 'sweetalert2'

/**
 * เมื่อ backend ส่ง 401 + code SESSION_REPLACED (มีการล็อกอินจากที่อื่น)
 * แสดง SweetAlert นับถอยหลัง 5 วินาที (ห้ามกดปิด) จากนั้นล้าง auth และ reload
 */
export async function handleSessionReplaced(): Promise<void> {
  let countDown = 5
  await Swal.fire({
    title: 'บัญชีถูกใช้งานจากอุปกรณ์อื่น',
    html: `
      <div class="modern-session-swal-body">
        <div class="modern-session-swal-icon-wrap modern-session-swal-icon-wrap--danger">
          <div class="modern-session-swal-icon modern-session-swal-icon--danger">!</div>
        </div>
        <p class="modern-session-swal-message">
          มีการเข้าสู่ระบบบัญชีนี้จากอุปกรณ์หรือแท็บอื่น เพื่อความปลอดภัย ระบบจะพาคุณกลับไปหน้าแรกอัตโนมัติ
        </p>
        <div class="modern-session-swal-timer-card modern-session-swal-timer-card--danger">
          <div id="session-replaced-countdown" class="modern-session-swal-timer-value">${countDown}</div>
          <div class="modern-session-swal-timer-caption">วินาทีก่อนออกจากระบบ</div>
        </div>
      </div>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    timer: 5000,
    timerProgressBar: true,
    backdrop: 'rgba(2, 6, 23, 0.86)',
    customClass: {
      popup: 'modern-session-swal-popup modern-session-swal-popup--danger',
      title: 'modern-session-swal-title',
      htmlContainer: 'modern-session-swal-html',
    },
    didOpen: () => {
      const el = document.getElementById('session-replaced-countdown')
      if (!el) return
      const iv = setInterval(() => {
        countDown -= 1
        el.textContent = String(Math.max(0, countDown))
        if (countDown <= 0) clearInterval(iv)
      }, 1000)
    },
  })

  // ตัดการเชื่อมต่อ WebSocket ก่อน เพื่อให้ gateway แจ้ง user_offline ทันที (admin เห็น offline ไม่ค้าง)
  try {
    const win = window as unknown as { __huayWebSocket?: { disconnect?: () => void; removeAllListeners?: () => void; close?: () => void } }
    if (win.__huayWebSocket) {
      win.__huayWebSocket.removeAllListeners?.()
      win.__huayWebSocket.disconnect?.()
      win.__huayWebSocket.close?.()
      win.__huayWebSocket = undefined
    }
  } catch {
    /* ignore */
  }

  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('deviceId')
  localStorage.removeItem('user')
  localStorage.removeItem('tenantId')
  localStorage.removeItem('rememberMe')
  sessionStorage.removeItem('accessToken')
  sessionStorage.removeItem('refreshToken')
  sessionStorage.removeItem('deviceId')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('tenantId')
  sessionStorage.removeItem('rememberMe')
  if (typeof window !== 'undefined') {
    // กลับไปหน้าแรก (/) — ใช้ hash ให้ตรงกับ HashRouter แล้ว reload เพื่อล้าง state
    window.location.hash = '#/'
    window.location.reload()
  }
}
